<script>
import { mapState } from 'vuex'

export default {
    name: 'TableHandler',

    data() {
        return {
            currentPage: 1,
            pageOptions: [10, 25, 50, 100],
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,

            items: [],

            hasErrors: false,
            errorMessage: '',

            loading: true,

            tableKey: 'tbk',
            filterable: true,

            totalRows: 0,
        }
    },

    computed: {
        ...mapState({
            perPage: (state) => state.browsing.perPage,
            search: (state) => state.reportingVM.search,
        }),

        legend() {
            if (this.totalRows === 0) {
                return "AUCUN ÉLÉMENT N'A ETE TROUVÉ"
            }
            const start = (this.currentPage - 1) * this.perPage + 1
            const end =
                this.totalRows < this.perPage
                    ? this.totalRows
                    : this.perPage * this.currentPage
            return `AFFICHAGE DE L'ÉLÉMENT ${start} À ${end} SUR ${this.totalRows} ÉLÉMENTS`
        },
    },

    mounted() {
        this.filter = this.search
    },

    methods: {
        setSearch() {
            this.$store.commit('reportingVM/SET_SEARCH', this.filter)
        },

        resetSearch() {
            this.filter = null
            this.$store.commit('reportingVM/RESET_SEARCH')
        },

        handleErrors() {
            this.loading = false
            this.errorMessage =
                "Une erreur s'est produite, les données n'ont pu être chargées. Veuillez réactualiser la page."
            this.hasErrors = true
        },

        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        setPerPage(perPage) {
            this.$store.commit('browsing/SET_PER_PAGE', perPage)
        },

        filterItems(id) {
            this.items = this.items.filter((item) => item.id !== id)
            this.tableKey = Date.now()
        },

        updateTotalRows() {
            this.totalRows = this.filterable
                ? this.filteredItems.length
                : this.items.length
        },
    },
}
</script>

<style scoped></style>
